// extracted by mini-css-extract-plugin
export default {"hero-landing":"HeroLanding_hero-landing__4+E6B"};